import { isEmpty } from "lodash";
import { useData } from "../../../context/GetDataContext";
import { LoadStatus } from "../LoadStatus";
import { Checkbox, FormControlLabel } from "@mui/material";
import { LoadStatusTracker } from "../LoadStatusTracker";

const LoadHasDispatch = () => {
  const { data } = useData();
  const loadHasDispatch = !isEmpty(data?.LoadDispatch);
  return (
    <>
      {loadHasDispatch && (
        <>
          <div className="flex gap-3 text-xs mb-3">
            <div>
              <LoadStatus data={data} />
            </div>
            <div>
              <button className="bg-blue-500 text-white px-2 py-2 rounded text-xs">
                LTL
              </button>
            </div>
            <div>
              <button className="bg-red-500 text-white px-2 py-2 rounded text-xs">
                Hazmat?
              </button>
            </div>
            <div>
              <FormControlLabel
                control={<Checkbox size="small" />}
                label="Primary Unit?"
                sx={{
                  marginRight: "0",
                  ".MuiTypography-root": {
                    fontSize: "0.9rem",
                  },
                }}
              />
            </div>
            <div>
              <FormControlLabel
                control={<Checkbox size="small" />}
                label="Local Trip?"
                sx={{
                  marginRight: "0",
                  ".MuiTypography-root": {
                    fontSize: "0.9rem",
                  },
                }}
              />
            </div>
          </div>
          <LoadStatusTracker data={data} />
        </>
      )}
    </>
  );
};

export default LoadHasDispatch;
